export default "__VITE_ASSET__Dgz4FqKQ__"